import Button from 'app/components/button';
import Dropdown from 'app/components/Dropdown';
import NewInput from 'app/components/NewInput';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { reportLiabilityHeader } from 'app/constants/table-header-constants';
import Csv from 'assets/images/csv-icon.svg';
import Excel from 'assets/images/xls-icon.svg';
import useLiabilityReport from './useLiabilityReport';

const LiabilityReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    values,
    fetchReportData,
    mallList,
    setChange,
    setChangegetvalue,
    handleSubmit,
  } = useLiabilityReport();
  if (!sectionObj) return null;

  const { sectionTitle, downloadObj } = sectionObj;
  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
            <div className='wd-25'>
              <Dropdown
                id={'mallId'}
                label='Mall name*'
                name='mallId'
                options={mallList ?? []}
                placeholder='Select Mall '
                value={values?.mallId ? values?.mallId : null}
                handleChange={setChange}
              />
            </div>
            <div className='wd-25'>
              <NewInput
                label='Start Date*'
                id='startDate'
                placeholder='DD-YY-MMMM'
                name='startDate'
                format='DD-MM-YYYY'
                type={'date'}
                max={values.endDate && values.endDate}
                value={values?.startDate}
                onChange={setChange}
              />
            </div>
            <div className='wd-25'>
              <NewInput
                label='End Date*'
                name='endDate'
                id='endDate'
                placeholder={'End Date'}
                min={values.startDate && values.startDate}
                value={values?.endDate}
                type={'date'}
                onChange={setChangegetvalue}
              />
            </div>
            <div className='wd-25 flex justify-content-start align-items-center'>
              <Button
                className='mt1'
                onClick={handleSubmit}
                variant='Save'
                name='Submit'
                isDisabled={
                  !values.mallId || !values.startDate || !values.endDate
                }
              />
            </div>
            <div></div>
          </div>
          <div className='d-flex justify-content-between'>
            <h4>{sectionTitle}</h4>
            <div className='content-container__actionBox'>
              {downloadObj && (
                <>
                  <span
                    className='link cursor-pointer download'
                    onClick={(e) =>
                      downloadObj.csvClick && downloadObj.csvClick(e)
                    }
                  >
                    <img alt={'csv'} src={Csv} />
                  </span>
                  <span
                    className='link cursor-pointer download'
                    onClick={(e) =>
                      downloadObj.excelClick && downloadObj.excelClick(e)
                    }
                  >
                    <img alt={'excel'} src={Excel} />
                  </span>
                </>
              )}
            </div>
          </div>
          <PaginatedTable
            fulldata={filteredData}
            columns={reportLiabilityHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            values={values}
          />
        </div>
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default LiabilityReport;
